import { render, staticRenderFns } from "./RelatorioExportacaoLogProduto.vue?vue&type=template&id=3994d05f"
import script from "./RelatorioExportacaoLogProduto.vue?vue&type=script&lang=js"
export * from "./RelatorioExportacaoLogProduto.vue?vue&type=script&lang=js"
import style0 from "./RelatorioExportacaoLogProduto.vue?vue&type=style&index=0&id=3994d05f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports